/**
 * Weight + dimensions unit helpers.
 *
 * STORAGE invariant: all weight values are persisted in **kilograms** in the DB,
 * regardless of the studio's chosen display system. Conversion only happens at
 * the I/O boundary (display formatting + user input parsing).
 */

export const KG_TO_LB = 2.2046226218;
export const CM_TO_IN = 0.3937007874;

export const weightLabel = (system) => (system === "imperial" ? "lb" : "kg");
export const lengthLabel = (system) => (system === "imperial" ? "in" : "cm");

/** Format a kg value for display in the chosen system. */
export const formatWeight = (kg, system, precision = 2) => {
  if (kg === null || kg === undefined || kg === "" || isNaN(kg)) return "";
  const n = Number(kg);
  if (system === "imperial") return `${(n * KG_TO_LB).toFixed(precision)} lb`;
  return `${n.toFixed(precision)} kg`;
};

/** Convert a value the user typed (in the system's unit) back to kg for storage. */
export const inputToKg = (value, system) => {
  if (value === null || value === undefined || value === "") return 0;
  const n = Number(value);
  if (isNaN(n)) return 0;
  if (system === "imperial") return Number((n / KG_TO_LB).toFixed(4));
  return Number(n.toFixed(4));
};

/** Convert a kg value to the user's preferred unit for prefilling an input. */
export const kgToInput = (kg, system, precision = 2) => {
  if (kg === null || kg === undefined || kg === "" || isNaN(kg)) return "";
  const n = Number(kg);
  if (system === "imperial") return Number((n * KG_TO_LB).toFixed(precision));
  return Number(n.toFixed(precision));
};

/** Length helpers — values are stored as cm floats in the DB. */
export const cmToInput = (cm, system, precision = 2) => {
  if (cm === null || cm === undefined || cm === "" || isNaN(cm)) return "";
  const n = Number(cm);
  if (system === "imperial") return Number((n * CM_TO_IN).toFixed(precision));
  return Number(n.toFixed(precision));
};

export const inputToCm = (value, system) => {
  if (value === null || value === undefined || value === "") return 0;
  const n = Number(value);
  if (isNaN(n)) return 0;
  if (system === "imperial") return Number((n / CM_TO_IN).toFixed(4));
  return Number(n.toFixed(4));
};
